export default __webpack_public_path__ + "static/media/aidchat.72dd189e.png";